<template>
  <div
    id="dropdown-menu-area"
    :class="isMenuDisplayed ? 'dropdown-menu' : 'hide'"
    v-click-outside="vcoConfig"
  >
    <div v-for="item in dropdownItems" :key="item.name">
      <div @click="item.method" class="dropdown-item" :class="item.iconName">
        <base-icon :name="item.iconName"></base-icon>
        <span class="small-text">{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { BaseIcon } from "@/components";

export default {
  name: "DropdownMenu",
  components: {
    BaseIcon,
  },
  props: ["isMenuDisplayed", "toggleMenu"],

  data() {
    return {
      dropdownItems: [
        { iconName: "settings", name: "Ayarlar", method: "" },
        { iconName: "logout", name: "Çıkış", method: this.signOut },
      ],

      vcoConfig: {
        handler: this.handler,
        middleware: this.middleware,
        events: ["click"],
      },
    };
  },
  methods: {
    ...mapActions(["logout"]),
    middleware(event) {
      return event.target.className?.baseVal !== "toggle-dropdown";
    },
    signOut() {
      return this.logout();
    },
    handler() {
      this.toggleMenu({ isOutside: true });
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-menu {
  background: var(--grayscale-0);
  position: absolute;
  right: 30px;
  top: 60px;
  cursor: pointer;
  box-shadow: 0 4px 8px 0 var(--grayscale-30);
  border-radius: var(--radius-first);
  font-size: 13px;

  @media (max-width: 768px) {
    right: auto;
    left: 15px;
    top: 127px;
    z-index: 1;
  }
  > div:first-child {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    display: none;
  }

  > div:last-child {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .dropdown-item {
    display: flex;
    align-items: center;
    padding: 10px;
    font-size: 14px;
    &:hover {
      background: var(--grayscale-10);
    }

    svg {
      margin-right: 10px;
    }
  }
}

.hide {
  display: none;
}
</style>
